import { store } from '../../redux/store';
import { useOnNewNotificationSubscription } from '../generated';
import { selectIsAuthenticated } from '../../redux/selectors/index';

export function useLatestServerNotification() {
  const isAuthenticated = selectIsAuthenticated(store.getState());
  return useOnNewNotificationSubscription({ skip: !isAuthenticated });
}
